import { inject, Injectable } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { catchError, filter, first, Observable, of, switchMap, tap } from 'rxjs';
import { Api } from 'src/app/core/common/api';
import { Auth } from 'src/app/core/common/auth';
import { IAppConfigsDto } from 'src/app/core/contracts';

@Injectable()
export class Configs {
  private auth = inject(Auth);
  private api = inject(Api);

  configs = {} as IAppConfigsDto;
  loadConfigs(forceUpdate?: boolean): Observable<IAppConfigsDto> {
    if (forceUpdate || isEmpty(this.configs)) {
      return this.auth.isReady$.pipe(
        filter(ready => ready),
        first(),
        switchMap(() => this.api.get<IAppConfigsDto>('configs', { handleError: false })),
        catchError(() => of({} as IAppConfigsDto)),
        tap(configs => (this.configs = configs || ({} as IAppConfigsDto))),
        tap(() => this.applyCustomChanges())
      );
    }
    return of(this.configs);
  }
  applyCustomChanges(): void {
    // e.g: this.configs.theme?.useNationalDayTheme ? document.documentElement.classList.add('national-day')
  }
}
